import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { ROUTES } from 'app/constants';

export const PrivateRoute = ({ children }: { children: ReactElement }) => {
  const { isLogged, isAuthLoading } = useAppSelector(
    (state) => state.authState,
  );

  // Render children optimistically while auth is still resolving; they can
  // show their own skeleton UI. Only redirect once we know the user is out.
  if (!isAuthLoading && !isLogged) {
    return <Navigate to={ROUTES.SIGN_IN} replace />;
  }
  return children;
};
